import InitApi from "api/InitApi";
import ServerErrors from "components/SeverErrors";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import useCartStore from "store/cartStore";
import useTokenStore from "store/tokenStore";
import useUserIp from "hooks/useUserIp";
import { deleteEmptyObjects } from "utils";

const useAddToCart = () => {
	const queryClient = useQueryClient();
	const { accessToken } = useTokenStore();
	const { userIp } = useUserIp();

	const { setAddToCartIsSuccessful } = useCartStore();

	const history = useHistory();

	const addToCart = async (obj) => {
		const instance = await InitApi({ accessToken, userIp });
		const body = deleteEmptyObjects(obj);
		const response = await instance.post(`/carts`, body);
		await queryClient.invalidateQueries("user_cart_count");
		await queryClient.invalidateQueries("user_cart_items");
		await queryClient.invalidateQueries("picks");
		return response;
	};

	return useMutation(addToCart, {
		onSuccess: async ({ data: body }) => {
			setAddToCartIsSuccessful(true);
		},
		onError: async (error) => {
			const errorData = error?.response?.data;
			const errorType = errorData?.error;

			// Handle geo-restriction specific errors
			if (errorType === "VPN_DETECTED") {
				toast.error(
					"VPN Detected: Please disable your VPN to purchase this book. We need to verify your location to comply with regional restrictions.",
					{
						className: "max-w-max",
						duration: 6000,
					}
				);
				return;
			}

			if (errorType === "GEO_RESTRICTED") {
				toast.error(errorData?.message || "This book is not available in your region.", {
					className: "max-w-max",
					duration: 6000,
				});
				return;
			}

			if (errorType === "LOCATION_UNKNOWN") {
				toast.error(
					"We could not determine your location. Please try again or contact support if the issue persists.",
					{
						className: "max-w-max",
						duration: 6000,
					}
				);
				return;
			}

			// Default error handling
			toast.error(
				<ServerErrors
					errorMessage={error?.response?.data?.message}
					errors={error?.response?.data?.data}
				/>,
				{
					className: "max-w-max",
				}
			);

			if (error?.response?.data.message === "Unauthenticated.") {
				reactLocalStorage.clear();
				history.push("/");
			}
		},
	});
};

export default useAddToCart;
